import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

const { colors, common, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	keyFactItem: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
		justifyContent: 'space-between',
		listStyle: 'none',
		':hover': {
			':nth-child(1n) .company-key-fact-actions': {
				display: 'flex',
			},
		},
		':nth-child(1n) .deleting': {
			display: 'flex',
		},
	},
	keyFactItemActions: {
		alignItems: 'center',
		display: 'none',
		flexDirection: 'row',
		gap: spacing.xs,
		justifyContent: 'center',
	},
	keyFactItemDate: {
		alignItems: 'center',
		color: colors.text.light,
		display: 'flex',
		flexShrink: 0,
		fontSize: typography.fontSizes.xxs,
	},
	keyFactItemValue: {
		color: colors.text.main,
		fontSize: typography.fontSizes.xs,
		lineHeight: 1.5,
		overflow: 'hidden',
		paddingLeft: spacing.xs,
		paddingRight: spacing.xs,
		textOverflow: 'ellipsis',
		whiteSpace: 'pre-wrap',
	},
	keyFactItemValueContainer: {
		backgroundColor: colors.background.main,
		borderRadius: common.borderRadius,
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.xs,
		padding: spacing.xs,
		width: 'fit-content',
	},
	keyFactsContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
	},
	keyFactsIcon: {
		minHeight: 24,
		minWidth: 24,
	},
	keyFactsList: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	keyFactsListContainer: {
		width: '100%',
	},
});
